var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgErrorIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 13C8.55228 13 9 12.5523 9 12C9 11.4477 8.55228 11 8 11C7.44772 11 7 11.4477 7 12C7 12.5523 7.44772 13 8 13Z",
    fill: "#7B341E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 4.5V9.5",
    stroke: "#7B341E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.741037 12.776L6.97004 1.20804C7.07022 1.0221 7.21887 0.866753 7.40021 0.758472C7.58156 0.650191 7.78883 0.593018 8.00004 0.593018C8.21125 0.593018 8.41852 0.650191 8.59986 0.758472C8.7812 0.866753 8.92985 1.0221 9.03004 1.20804L15.259 12.776C15.3548 12.9542 15.4028 13.1543 15.3982 13.3565C15.3936 13.5588 15.3367 13.7564 15.2329 13.9301C15.1291 14.1038 14.9821 14.2476 14.8062 14.3475C14.6302 14.4474 14.4314 14.4999 14.229 14.5H1.77104C1.56871 14.4999 1.36987 14.4474 1.19392 14.3475C1.01797 14.2476 0.870936 14.1038 0.767167 13.9301C0.663397 13.7564 0.606442 13.5588 0.601862 13.3565C0.597283 13.1543 0.645235 12.9542 0.741037 12.776V12.776Z",
    stroke: "#7B341E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorIcon);
export default __webpack_public_path__ + "static/media/error-icon.eb950519.svg";
export { ForwardRef as ReactComponent };